import { Editor, useEditorState } from '@tiptap/react'
import { Button, Tooltip } from 'antd'
import { QuoteDown } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

type Props = {
  editor: Editor
}

export const BlockquoteButton = ({ editor }: Props) => {
  const { t } = useTranslation()

  const editorState = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isBlockquote: ctx.editor.isActive('blockquote') ?? false
      }
    }
  })

  const onToggleBlockquote = () => {
    editor.chain().focus().toggleBlockquote().run()
  }

  return (
    <Tooltip title={t('editor.blockquote')}>
      <Button
        icon={<QuoteDown size={14} />}
        onClick={onToggleBlockquote}
        type={editorState.isBlockquote ? 'primary' : 'default'}
      />
    </Tooltip>
  )
}
